// ===== Interfaces =====

import { ICoord } from '../interfaces';

export interface IReadOnlyAudioTextTouchGesture extends ICoord {
    moved: boolean,
}

export const READ_ONLY_AUDIO_TEXT_TOUCH_TAP_MAX_MOVEMENT_PX = 10;

/**
 * Reader text seeking should only treat near-stationary touches as taps. Once
 * a touch moves past this threshold we treat the gesture as scrolling instead.
 */
export const touchGestureMovedBeyondTapThreshold = ({
    touchGesture,
    nextPoint,
    maxMovementPx = READ_ONLY_AUDIO_TEXT_TOUCH_TAP_MAX_MOVEMENT_PX,
}: {
    touchGesture: IReadOnlyAudioTextTouchGesture,
    nextPoint: ICoord,
    maxMovementPx?: number,
}): boolean => (
    Math.abs(nextPoint.x - touchGesture.x) > maxMovementPx
    || Math.abs(nextPoint.y - touchGesture.y) > maxMovementPx
);

/**
 * Resolves whether the completed touch gesture still counts as a deliberate
 * tap, which allows read-only post text to seek audio without hijacking scroll.
 */
const readOnlyAudioTextTouchGestureRepresentsTap = ({
    touchGesture,
    touchPoint,
    maxMovementPx = READ_ONLY_AUDIO_TEXT_TOUCH_TAP_MAX_MOVEMENT_PX,
}: {
    touchGesture: IReadOnlyAudioTextTouchGesture | null,
    touchPoint: ICoord | null,
    maxMovementPx?: number,
}): boolean => {
    if (!touchGesture || !touchPoint) {
        return false;
    }

    if (touchGesture.moved) {
        return false;
    }

    return !touchGestureMovedBeyondTapThreshold({
        touchGesture,
        nextPoint: touchPoint,
        maxMovementPx,
    });
};

export default readOnlyAudioTextTouchGestureRepresentsTap;
